import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"position":"fixed","right":"10px","bottom":"60px","z-index":"10"}
}
const _hoisted_2 = { class: "ma-0" }
const _hoisted_3 = {
  key: 0,
  class: "ma-0 text-subtitle-1"
}
const _hoisted_4 = { class: "ma-0" }
const _hoisted_5 = {
  key: 0,
  class: "ma-0 text-subtitle-1"
}
const _hoisted_6 = { style: {"overflow":"hidden"} }
const _hoisted_7 = { class: "d-flex flex-column bg-white w-100" }
const _hoisted_8 = { class: "textarea-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_ChatConversation = _resolveComponent("ChatConversation")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_ChatManager = _resolveComponent("ChatManager")!
  const _component_v_card_action = _resolveComponent("v-card-action")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_resize = _resolveDirective("resize")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(
                _ctx.cardMode
                    ? ''
                    : 'position: fixed; right: 20px; bottom: 1vh; z-index: 10; display: none !important;'
            )
          }, [
            _withDirectives((_openBlock(), _createBlock(_component_v_avatar, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialog = !_ctx.showDialog)),
              style: _normalizeStyle(_ctx.cardMode ? '' : 'float: right; box-shadow: 10px 10px 7px rgba(0,0,0,0.06)'),
              id: "chat-btn-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_badge, {
                  "model-value": _ctx.unreadMessageCount !== 0,
                  color: "primary",
                  class: "align-self-center",
                  content: _ctx.unreadMessageCount
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "x-large" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("$fa-comments")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model-value", "content"])
              ]),
              _: 1
            }, 8, ["style"])), [
              [_vShow, !_ctx.showDialog],
              [_directive_resize, _ctx.handleChatBtnAnimation]
            ])
          ], 4)), [
            [_vShow, !_ctx.showDialog]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_avatar, {
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = !_ctx.showDialog)),
              style: {"float":"right","box-shadow":"10px 10px 7px rgba(0, 0, 0, 0.06)"},
              icon: "$fa-comments",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_badge, {
                  "model-value": _ctx.unreadMessageCount !== 0,
                  color: "primary",
                  class: "align-self-center",
                  content: _ctx.unreadMessageCount
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "small" }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("$fa-comments")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model-value", "content"])
              ]),
              _: 1
            })
          ], 512)), [
            [_vShow, !_ctx.showDialog]
          ]),
      (_ctx.$vuetify.display.mobile && !_ctx.cardMode)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 2,
            modelValue: _ctx.showDialog,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDialog) = $event)),
            fullscreen: "",
            "hide-overlay": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                style: {"margin":"0","margin-bottom":"-1vh"},
                rounded: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, {
                    class: "chat-header bg-primary p-5",
                    color: "primary-foreground"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { wrap: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "11" }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.chatTitle), 1),
                              (_ctx.chatSubtitle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.chatSubtitle), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_icon, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog = !_ctx.showDialog)),
                                class: "ma-0",
                                icon: _ctx.showDialog ? '$remove' : '$add',
                                color: "primary-foreground"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.showDiscussion)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 0,
                        id: "chatMessages",
                        ref: "chatMessages",
                        style: {"overflow":"hidden"},
                        class: "pa-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ChatConversation, {
                            messages: _ctx.messages,
                            ref: "chatConversation"
                          }, null, 8, ["messages"])
                        ]),
                        _: 1
                      }, 512))
                    : _createCommentVNode("", true),
                  (_ctx.showDiscussion)
                    ? (_openBlock(), _createBlock(_component_v_card_action, {
                        key: 1,
                        absolute: "",
                        class: "font-weight-medium pb-3",
                        color: "primary-foreground"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_divider),
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.messageToSend,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.messageToSend) = $event)),
                                onKeyup: _withKeys(_ctx.send, ["enter"]),
                                "append-inner-icon": "$send",
                                placeholder: "Saisir votre message...",
                                "onClick:appendInner": _cache[4] || (_cache[4] = ($event: any) => (_ctx.send())),
                                rows: "1",
                                "bg-color": "grey-lighten-3",
                                class: "chat-textarea"
                              }, null, 8, ["modelValue", "onKeyup"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "py-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ChatManager, {
                                id: _ctx.chatID,
                                chatType: _ctx.chatType,
                                onChatID: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setChatID($event))),
                                onShowDiscussion: _cache[6] || (_cache[6] = ($event: any) => (_ctx.discussionManager($event))),
                                onQuestionsNotReply: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setBlink($event))),
                                onTextToInsert: _cache[8] || (_cache[8] = ($event: any) => (_ctx.insertMessage($event)))
                              }, null, 8, ["id", "chatType"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : (_ctx.showDialog)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              style: _normalizeStyle(
                _ctx.cardMode
                    ? 'box-shadow: none; padding: 0px'
                    : 'position: fixed; right: 20px; width: 318px; bottom: 1vh; z-index: 10; min-width: 318px; min-height: auto; max-width: 600px; max-height: 500px; overflow: auto;'
            ),
              class: "resize-container d-flex flex-column align-items-start overflow-none"
            }, [
              _createElementVNode("div", {
                class: "resize-handler",
                onClick: _cache[10] || (_cache[10] = () => {})
              }),
              (!_ctx.cardMode)
                ? (_openBlock(), _createBlock(_component_v_toolbar, {
                    key: 0,
                    class: "elevation-0 py-2",
                    rounded: "0",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.chatTitle), 1),
                          (_ctx.chatSubtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.chatSubtitle), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn_icon, {
                        onClick: _ctx.closeChat,
                        class: "ma-0",
                        color: "primary-foreground",
                        icon: _ctx.showDialog ? '$remove' : '$add'
                      }, null, 8, ["onClick", "icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ChatConversation, { messages: _ctx.messages }, null, 8, ["messages"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ChatManager, {
                  id: _ctx.chatID,
                  chatType: _ctx.chatType,
                  class: "pa-0",
                  onChatID: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setChatID($event))),
                  onShowDiscussion: _cache[12] || (_cache[12] = ($event: any) => (_ctx.discussionManager($event))),
                  onQuestionsNotReply: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setBlink($event))),
                  onTextToInsert: _cache[14] || (_cache[14] = ($event: any) => (_ctx.insertMessage($event)))
                }, null, 8, ["id", "chatType"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_textarea, {
                    class: "my-textarea",
                    modelValue: _ctx.messageToSend,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.messageToSend) = $event)),
                    onKeyup: _withKeys(_ctx.send, ["enter"]),
                    "append-inner-icon": "$send",
                    placeholder: "Saisir votre message...",
                    "onClick:appendInner": _cache[16] || (_cache[16] = ($event: any) => (_ctx.send())),
                    rows: "2",
                    "no-resize": "",
                    "bg-color": "grey-lighten-3"
                  }, null, 8, ["modelValue", "onKeyup"])
                ])
              ])
            ], 4))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}